/* eslint-disable import/prefer-default-export */
import tmsApi from '../../../../../api/tmsApi';

export function loadShipmentOrders(token, shipmentId) {
  const api = tmsApi.build(token, 'shipment_md');
  const query = `
    {
      orders(shipment_id: ${shipmentId}) {
        id
        number
        sequence
        metadata
        created_at
        updated_at
        destination {
          id
          code
          name
        }
        customer {
          external_id
          name
          address {
            city
            state
            country
            zip_code
            address1
            address2
          }
        }
        confirmations {
          key
          name
          signature
          created_at
          metadata
        }
        units {
          number
          type
        }
        external_id
      }
    }
  `;
  return api(query, 'orders').then(({ data }) => {
    const { orders } = data;
    return orders;
  });
}



// WEBPACK FOOTER //
// ./src/views/pages/shipment_md/shipments/detail/useShipmentDetail.js